// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import LoadingIcon from '../../../components/LoadingIcon'

const S = {
  Container: styled.div`
    display: flex;
    position: relative;
  `,
  EndButton: styled.button<{ buttonType?: string }>`
    font-family: 'Noto Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #EF8200;
    cursor: pointer;
    min-height: 25px;
    border-radius: 4px;
    padding: 0px;
    width: 85px;
    margin: 0 5px;

    &:hover {
      background-color: #FCA032;
      color: white;
    }
  `,
  PopupContainer: styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    left: -240px;
    top: 25px;
    z-index: 1;
  `,
  Triangle: styled.div`
    width: 0;
    margin-left: 280px;
    border-style: solid;
    border-width: 0 7px 9px 7px;
    border-color: transparent transparent #434343 transparent;
    border-radius: 1px;
  `,
  Content: styled.div`
    width: 327px;
    padding: 19px 17px 11px 18px;
    font-family: 'Noto Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    color: #FFFFFF;
    background: #434343;
    border-radius: 4px;
  `,
  ButtonContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
  `,
  Button: styled.button`
    padding: 0px;
    cursor: pointer;
    margin-left: 33px;
    font-size: 16px;
    line-height: 22px;
    color: #EFEFEF;

    &:hover {
      color: #FCA032;
    }
  `
}

function useClosePopup<T extends HTMLElement>(isPopupShow: boolean, closePopup: () => void) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!isPopupShow) return;

    function handleClosePopup(e: MouseEvent) {
      console.log(ref.current, e.target)
      if (!ref.current?.contains(e.target as Node)) {
        closePopup();
      }
    }

    window.addEventListener('click', handleClosePopup);

    return () => {
      window.removeEventListener('click', handleClosePopup);
    }
  }, [isPopupShow, closePopup, ref.current])

  return ref;
}

// const QuitChallengeButton: React.FC<React.ComponentPropsWithRef<'div'>> = props => {
const QuitChallengeButton = (props: any): JSX.Element => {
  const [isPopupShow, setPopupShow] = useState(false);
  const closePopup = useCallback(() => setPopupShow(false), [])
  const ref = useClosePopup<HTMLDivElement>(isPopupShow, closePopup);
  const handleEndChallenge = props.handleEndChallenge;
  const [isConfirm, setConfirm] = useState(false);
  const togglePopup = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setPopupShow(!isPopupShow)
  }, [isPopupShow]);

  const handleConfirm = () => {
    handleEndChallenge();
    setConfirm(true);
  }

  return (
    <S.Container ref={ref} {...props}>
      <S.EndButton onClick={togglePopup}><FormattedMessage id="E059" /></S.EndButton>
      {isPopupShow && <S.PopupContainer {...props}>
        <S.Triangle />
        <S.Content>
          <FormattedMessage id="E063" values={{ br: <br /> }} />
          <br /><br />
          <S.ButtonContainer>
            <S.Button onClick={togglePopup}><FormattedMessage id="E065" /></S.Button>
            <S.Button onClick={() => handleConfirm()}>
              {isConfirm ? <LoadingIcon size={5} /> : <FormattedMessage id="E064" />}
            </S.Button>
          </S.ButtonContainer>
        </S.Content>
      </S.PopupContainer>}
    </S.Container>
  )
}

export { QuitChallengeButton as default };
